import { Stack, Text } from '@ltvco/refresh-lib/theme';

import { formatShorthandDate } from 'routes/SearchPerson/Cards/NewCardsDesignVariation1/common/utils';

import { ObituaryReportSummaryData } from '../DataTypes/SummaryTypes';

interface ObituaryReportRendererProps {
  data: ObituaryReportSummaryData;
}

export const ObituaryReportRenderer = ({
  data,
}: ObituaryReportRendererProps) => {
  return (
    <Stack spacing={3} py={2}>
      <Text>
        <span style={{ fontWeight: 700 }}>{data.personName}</span> passed away
        on{' '}
        <span style={{ fontWeight: 700 }}>
          {data.dateOfDeath
            ? typeof data.dateOfDeath === 'string'
              ? data.dateOfDeath
              : formatShorthandDate(data.dateOfDeath)
            : 'an unknown date.'}
        </span>
      </Text>
      <Stack spacing={1.5}>
        <Text>
          <span style={{ fontWeight: 700 }}>Summary</span>
        </Text>
        <Text>
          <span style={{ fontWeight: 700 }}>Age at Death:</span>{' '}
          {data.age || '-'}
        </Text>
        <Text>
          <span style={{ fontWeight: 700 }}>Date of Birth:</span>{' '}
          {data.dateOfBirth
            ? typeof data.dateOfBirth === 'string'
              ? data.dateOfBirth
              : formatShorthandDate(data.dateOfBirth)
            : '-'}
        </Text>
        <Text>
          <span style={{ fontWeight: 700 }}>Date of Death:</span>{' '}
          {data.dateOfDeath
            ? typeof data.dateOfDeath === 'string'
              ? data.dateOfDeath
              : formatShorthandDate(data.dateOfDeath)
            : '-'}
        </Text>
      </Stack>
      <Stack spacing={1.5}>
        <Text>
          <span style={{ fontWeight: 700 }}>Background</span>
        </Text>
        <Text>
          <span style={{ fontWeight: 700 }}>Place of Birth:</span>{' '}
          {data.placeOfBirth || '-'}
        </Text>
        <Text>
          <span style={{ fontWeight: 700 }}>Residence:</span>{' '}
          {data.location || '-'}
        </Text>
      </Stack>
      <Stack spacing={1.5}>
        <Text>
          <span style={{ fontWeight: 700 }}>Relatives</span>
        </Text>
        {data.relatives?.length > 0 ? (
          data.relatives.map((relative) => (
            <Text key={relative}>• {relative}</Text>
          ))
        ) : (
          <Text>-</Text>
        )}
      </Stack>
      <Stack spacing={1.5}>
        <Text>
          <span style={{ fontWeight: 700 }}>Obituary</span>
        </Text>
        <Text>{data.obituaryText || '-'}</Text>
      </Stack>
    </Stack>
  );
};
